export const instanceName = 'ClientSearchGeneral'

export const formName = 'frm_client_list'
